module.exports = "/_next/static/images/Compliance@2x-0de0066c7240b0beb61cb95646cbbb22.webp";